import styled from "styled-components";

export const Hint = styled.p`
  color: var(--font-color2);
  font-size: 0.8em;
  line-height: 1.2em;
  margin: 0.45em 0 0;
`;

export default Hint;
